import { db } from "../../firebase";
import styles from "./index.module.css";
import { useContext, useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { ThemeContext } from "../../context/ThemeContext";

export default function ProjectDetails(props) {
  const [productFeatures, setProductFeatures] = useState({
    title: [],
    price: [],
    description: [],
    image: [],
  });
  const [loading, setLoading] = useState(true);
  const { isDarkMode } = useContext(ThemeContext);
  const [theme, setTheme] = useState(isDarkMode);

  useEffect(() => {
    setTheme(isDarkMode);
  }, [isDarkMode]);

  useEffect(() => {
    async function getProductFeatures() {
      try {
        const docRef = collection(db, "products", `${props.productId}`, "permutations");
        const docSnap = await getDocs(docRef);

        const features = { title: [], price: [], description: [], image: [] };

        docSnap.forEach(data => {
          const imageUrl = data.data().image;
          if (imageUrl) {
            const cleanFilename = extractImageFilename(imageUrl);
            if (cleanFilename) {
              features.image.push({ url: imageUrl, filename: cleanFilename });
            }
          }

          features.title.push(data.data().title);
          features.price.push(data.data().price);
          features.description.push(data.data().description);
        });

        const uniqueAndNonEmptyFeatures = Object.fromEntries(
          Object.entries(features).map(([category, items]) => [
            category,
            [...new Set(
              items.map(item => {
                if (typeof item === 'object' && item !== null) {
                  return JSON.stringify(item);
                }
                return item;
              })
            )].filter(item => {
              if (typeof item === 'string' && item.trim() === "") {
                return false;
              }
              if (typeof item === 'string') {
                try {
                  const parsedItem = JSON.parse(item);
                  return parsedItem.filename.trim() !== "";
                } catch {
                  return true;
                }
              }
              return true;
            }).map(item => {
              try {
                return JSON.parse(item);
              } catch {
                return item;
              }
            }),
          ])
        );

        setProductFeatures(uniqueAndNonEmptyFeatures);
      } catch (error) {
        console.error("Error fetching product features:", error);
      } finally {
        setLoading(false);
      }
    }

    if (props.productId) {
      getProductFeatures();
    }
  }, [props.productId]);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const backgroundColorDarkMode = "#141414";
  const backgroundColorLightMode = "white";
  const textColorDarkMode = "white";
  const textColorLightMode = "black";

  return (
    <div onClick={() => props.setIsProjDetailsVisible(false)} className={styles.backdrop}>
      <div onClick={(e) => e.stopPropagation()} className={styles.popup} style={{ backgroundColor: theme ? backgroundColorDarkMode : backgroundColorLightMode }}>
        <h3>Question Features</h3>
        {loading ? (
          <div>Loading...</div>
        ) : Object.values(productFeatures).some(arr => arr.length > 0) ? (
          <div style={{ maxHeight: '300px', overflowY: 'auto', width: '100%' }}>
            <table style={{ width: '80%', margin: '0 auto' }}>
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Feature</th>
                </tr>
              </thead>
              <tbody>
                {["title", "image", "description", "price"]
                  .filter(category => productFeatures[category]?.length > 0)
                  .flatMap(category =>
                    productFeatures[category].map((feature, index) => (
                      <tr key={`${category}-${index}`}>
                        <td style={{ color: theme ? textColorDarkMode : textColorLightMode }}>
                          {capitalizeFirstLetter(category)}
                        </td>
                        <td style={{ color: theme ? textColorDarkMode : textColorLightMode }}>
                          {category === "image" ? (
                            feature ? (
                              <a
                                href={feature.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Open image"
                                style={{ color: "#007bff" }}
                              >
                                {feature.filename}
                              </a>
                            ) : (
                              "No Image"
                            )
                          ) : (
                            feature
                          )}
                        </td>
                      </tr>
                    ))
                  )}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ color: theme ? textColorDarkMode : textColorLightMode }}>No product features available</div>
        )}
      </div>
    </div>
  );
}

const extractImageFilename = (url) => {
  const decodedUrl = decodeURIComponent(url);
  const regex = /\/[^\/]+\/(?:[0-9a-fA-F-]{36}-)?([^\/]+?\.(jpg|jpeg|png|gif|webp|svg))/i;
  const match = decodedUrl.match(regex);
  if (!match) {
    return null;
  }
  const filename = match[1];
  return filename;
};